import { useMemo, useState } from "react";
import { useClients } from "../../../hooks/useClients";
import { Client } from "../../../models/client";
import ClientRow from "./client-row";

function ClientsList({ query }: { query: string }) {
  const clients = useClients();
  const [sortKind, setSortKind] = useState<"name" | "email" | "kind">("name");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

  const sortedItems = useMemo(() => {
    let items = [...(clients || [])];
    items.sort((a, b) => {
      let aSort = `${(a as any)[sortKind]}`.toLowerCase();
      let bSort = `${(b as any)[sortKind]}`.toLowerCase();
      if (aSort > bSort) return sortDirection === "asc" ? 1 : -1;
      if (aSort < bSort) return sortDirection === "asc" ? -1 : 1;
      return 0;
    });
    if (query) {
      return items.filter((item) =>
        `${item.name}`.toLowerCase().includes(query.toLowerCase()) ||
        `${item.email}`.toLowerCase().includes(query.toLowerCase())
      );
    }
    return items;
  }, [clients, sortKind, sortDirection, query]);

  const SortHeader = ({ col, label }: { col: typeof sortKind; label: string }) => (
    <th
      style={{ cursor: "pointer", userSelect: "none" }}
      onClick={() => {
        if (sortKind === col) setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        else { setSortKind(col); setSortDirection("asc"); }
      }}
    >
      {label} {sortKind === col ? (sortDirection === "asc" ? "↑" : "↓") : ""}
    </th>
  );

  return (
    <table className="p-table">
      <thead>
        <tr>
          <SortHeader col="name" label="Name" />
          <SortHeader col="kind" label="Type" />
          <SortHeader col="email" label="Email" />
          <th></th>
        </tr>
      </thead>
      <tbody>
        {sortedItems.length === 0 ? (
          <tr>
            <td colSpan={4} style={{ textAlign: "center", color: "var(--ink-soft)", padding: "40px 24px" }}>
              No clients found.
            </td>
          </tr>
        ) : (
          sortedItems.map((item, index) => (
            <ClientRow key={`client-${index}`} client={item} />
          ))
        )}
      </tbody>
    </table>
  );
}

export default ClientsList;
